import { MembershipsCreatorApiClient } from '@fourthwall/services/dist/MembershipsCreatorApiClient'
import { createMutationHook } from '@fourthwall/utils/dist/queries'

export const useReorderTierMutation = createMutationHook(MembershipsCreatorApiClient.reorderTier, {
  mutationKey: ['reorderTier'],
})
